export default "__VITE_ASSET___Zrif4oT__"